type TimeSlotLike = {
  time: string;
};

const CUSTOMER_TIME_ZONE = 'Asia/Phnom_Penh';

const clockFormatter = new Intl.DateTimeFormat('en-CA', {
  timeZone: CUSTOMER_TIME_ZONE,
  year: 'numeric',
  month: '2-digit',
  day: '2-digit',
  hour: '2-digit',
  minute: '2-digit',
  hour12: false,
});

const toMinutes = (hhmm: string) => {
  const [hour, minute] = String(hhmm).slice(0, 5).split(':').map(Number);
  if (!Number.isFinite(hour) || !Number.isFinite(minute)) return null;
  return hour * 60 + minute;
};

const getCurrentClock = () => {
  const parts = clockFormatter.formatToParts(new Date());
  const values = Object.fromEntries(parts.map((part) => [part.type, part.value]));
  return {
    ymd: `${values.year}-${values.month}-${values.day}`,
    minutes: toMinutes(`${values.hour}:${values.minute}`) ?? 0,
  };
};

export const isPastTimeSlot = (date: string, time: string) => {
  const current = getCurrentClock();
  if (date !== current.ymd) return false;

  const slotMinutes = toMinutes(time);
  if (slotMinutes == null) return false;
  return slotMinutes < current.minutes;
};

export const filterPastTimeSlots = <T extends TimeSlotLike>(date: string, slots: T[]) => {
  return slots.filter((slot) => !isPastTimeSlot(date, slot.time));
};
